import { fetchHelpPageSuccess, type fetchHelpPage} from "modules/actions/help";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga";

const fetchHelpPageSaga = function* (action: ReturnType<typeof fetchHelpPage>) {
	const result = yield* call(Api.Jsons[action.payload]);

	if (result?.data?.id) {
		yield* put(
			fetchHelpPageSuccess({
				[action.payload]: result,
			})
		);
	}
};

export default fetchHelpPageSaga;
